'use strict';

/**
 * Checks if local storage is enabled
 */ const isLocalStorageEnabled = ()=>{
    try {
        const key = `__storage__test`;
        window.localStorage.setItem(key, "");
        window.localStorage.removeItem(key);
        return true;
    } catch  {
        return false;
    }
};

exports.isLocalStorageEnabled = isLocalStorageEnabled;
//# sourceMappingURL=isLocalStorageEnabled.cjs.map
